import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from "rxjs/operators";
import { CommonConstants } from '../utilities/commonConstants';
import { ConfigService } from '../services/config.service';
import { AppIdleService } from '../services/app-idle.service';
import { SessionHandlerService } from '../services/sessionHandler.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

    constructor(private _appIdleService: AppIdleService, private _sessionHandler: SessionHandlerService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                tap(() => {
                    const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId);
                    if (applicationId) {
                        this._appIdleService.resetTimer();
                    }
                })
            )
    }
}